import { render, staticRenderFns } from "./EventMainSpeakerBlock.vue?vue&type=template&id=65d4d1ae"
import script from "./EventMainSpeakerBlock.vue?vue&type=script&lang=js"
export * from "./EventMainSpeakerBlock.vue?vue&type=script&lang=js"
import style0 from "./EventMainSpeakerBlock.vue?vue&type=style&index=0&id=65d4d1ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports